import ClientsAxios from '../client-axios';
import { handlePostRequest } from './requestHandler';

const { COMMUNITY_HEALTH_CAMP_SERVER } = ClientsAxios;

export const AddEditSchemeService = (payload: any, isEdit: boolean) =>
    handlePostRequest<any>(
        isEdit ? 'schemes/update' : 'schemes/create',
        payload,
        COMMUNITY_HEALTH_CAMP_SERVER
    );

export const FetchSchemeListService = (payload: any) =>
    handlePostRequest<any>('schemes/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const DeleteSchemeDetailsService = (payload: any) =>
    handlePostRequest<any>('schemes/delete', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchSchemeDetailsListService = (payload: any) =>
    handlePostRequest<any>('schemes/listing', payload, COMMUNITY_HEALTH_CAMP_SERVER);
